import React from 'react';

export default function LeafPattern({ className = '', color = '#3D4F3D' }) {
  return (
    <svg
      viewBox="0 0 400 500"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g opacity="0.15">
        <path
          d="M200 50 Q250 100 240 180 Q230 260 200 300 Q170 260 160 180 Q150 100 200 50Z"
          fill={color}
        />
        <path
          d="M200 50 L200 300"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M200 100 Q230 90 240 120"
          stroke={color}
          strokeWidth="1.5"
          fill="none"
        />
        <path
          d="M200 140 Q170 130 160 160"
          stroke={color}
          strokeWidth="1.5"
          fill="none"
        />
        <path
          d="M200 180 Q230 170 235 200"
          stroke={color}
          strokeWidth="1.5"
          fill="none"
        />
        <path
          d="M200 220 Q170 210 165 240"
          stroke={color}
          strokeWidth="1.5"
          fill="none"
        />
      </g>
      <g opacity="0.1" transform="translate(100, 150) rotate(-30)">
        <path
          d="M100 30 Q130 60 125 110 Q120 160 100 190 Q80 160 75 110 Q70 60 100 30Z"
          fill={color}
        />
        <path
          d="M100 30 L100 190"
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
      <g opacity="0.12" transform="translate(200, 200) rotate(25)">
        <path
          d="M100 30 Q130 60 125 110 Q120 160 100 190 Q80 160 75 110 Q70 60 100 30Z"
          fill={color}
        />
        <path
          d="M100 30 L100 190"
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
